/**
 * COMMERCIAL LANDSCAPING FEATURED PROJECT
 * Last updated: [Date will auto-update when edited]
 * 
 * Update this file to change the commercial landscaping featured project.
 */

const commercialProject = {
  category: "commercial",
  title: "Reimagining shared spaces for long-term beauty and function.",
  images: {
    topLeft: {
      top: "/images/projects/BeforeIsland1.jpeg",
      bottom: "/images/projects/emptyIsland1.jpeg",
      topAlt: "Commercial project before renovation",
      bottomAlt: "Commercial project during construction"
    },
    bottomLeft: {
      top: "/images/projects/finishedIsland.JPG",
      bottom: "/images/projects/FullerIsland.JPG",
      topAlt: "Commercial project in progress",
      bottomAlt: "Commercial project completed"
    }
  },
  paragraphs: [
    "When a neighborhood HOA approached us about their dated roundabout, we saw an opportunity to simplify and renew.",
    
    "We cleared and rebuilt the soil base and designed a clean layout using native grasses, hardy shrubs, and a low-profile irrigation system. The new design requires minimal maintenance but delivers maximum impact, creating a welcoming focal point for residents and guests alike.",
    
    "Working within community standards, our team found creative ways to modernize without compromising character. It's proof that even a small space can reflect thoughtful design and the value of lasting partnerships."
  ]
};

export default commercialProject;